<template>
  <div>
    

    <table>
      <tr>
        <td v-for="location in $locations" :key="location" valign="top">
          <h4>{{location}}</h4>
          <table>
            <tr><th>Dist</th><th>Name</th><th>Count</th></tr>
            <tbody v-if="filteredData.RCGB.topCigSales.length > 0">
              <tr v-for="d in filteredData[location].topCigSales" :key="d.ItemNum">
                <td>{{d.Distributor}}</td>
                <td>#{{d.rank}} {{d.ItemName}}</td>
                <td>
                  <span>
                    {{d.count}}pk 
                  </span>
                  <span>
                    ({{parseInt(d.count / d.unit_size)}}ct | {{d.cartons}} sold as ctn)
                  </span>
                </td>
              </tr>
              <tr>
                <td></td>
                <td align="right" style="font-weight:bold;">Total</td>
                <td style="font-weight:bold;">{{total[location].topCigSales.count}}pk</td>
              </tr>
            </tbody>

            <!-- Placeholder for empty data -->
            <tbody v-else>
              <tr v-for="index in qualifier.top" :key="index">
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>-</td>
              </tr>
            </tbody>
          </table> 
        </td>
      </tr>
    </table> 
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  name: 'TopCigSalesTable',
  props : ['value', 'timestamps', 'qualifier'],
  data () { return {
      categories: [],
      data: {
        RCGB: {topCigSales:[]},
        RMGB: {topCigSales:[]},
        WGB : {topCigSales:[]},
        All : {items: {}, topCigSales:[]},
      },
      // q: {
      //   top: 25,
      //   subtypes : ['CONF'],
      //   notSubtypes : ['Gas', 'CIGS', 'POP'],
      // }
    }
  },
  created : async function(){
    await this.loadCategories();
    this._loadData();
  },
  watch: {
    'timestamps.from' : 'loadData',
    'timestamps.to' : 'loadData',
    'qualifier.top' : 'loadData',
    'qualifier.subtypes' : 'loadData',
    'qualifier.notSubtypes' : 'loadData',
  },
  computed : {
    isLoading: function(){
      let result = false;
      this.$locations.forEach(location => {
        const l = this.data[location]
        result = result || l.topCigSales.isLoading;
      })
      return result;
    }
  },
  methods: {
    loadCategories: async function(){
      // let r = await this.$axios.get(`/api/WGB/categories`)
      let r = await this.$axios.get(`/api/RMGB/categories`)
      this.categories = r.data;
      console.log(this.categories)
    },
    loadData: _.debounce(function(){
      this._loadData()
    }, 800),
    _loadData: function(){
      console.log('loading data')
      if(this.timestamps.from === undefined || this.timestamps.to === undefined){
        return;
      }
      
      //Strip timezone from ts 
      let from = moment(this.timestamps.from).subtract(1,'day').format("YYYY-MM-DD HH:mm:ss");
      let to = moment(this.timestamps.to).subtract(1,'day').format("YYYY-MM-DD HH:mm:ss");
      console.log('from to', from, to)
      
      this.$locations.forEach(location=>{
      // ['RMGB'].forEach(location=>{
        const getData = (endpoint, dataKey) => {
          this.data[location][dataKey] = [];
          this.data[location][dataKey].isLoading = true;
          const options = { location, from, to, ...this.qualifier}
          this.$axios.post(endpoint, options).then((r)=>{
            r.data.forEach((r,i)=> r.rank = i + 1);
            this.data[location][dataKey].isLoading = false;
            this.data[location][dataKey] = r.data.length > 0 ? r.data : this.data[location][dataKey]
            this.$emit('input', this.data)
            
            // this.data[location][dataKey].forEach(r=>{
            //   if(this.data['All'].items[r.ItemNum] === undefined){
            //     this.data['All'].items[r.ItemNum] = r
            //   } else {

            //   }
            // })
            
          });
        }
        getData('/getTopCigSales', 'topCigSales')
        
      })
    },
  },
  computed: {
    total: function(){
      return this.$math.sumSubSubKeys(this.filteredData);
    },
    filteredData: function(){
      console.log('debug')
      const q = this.qualifier
      if(q.distributorFilter.length === 0 && q.includeFilter.length === 0 && q.excludeFilter.length === 0){
        return this.data
      } else {
        const result = {
          RCGB: {topCigSales:[]},
          RMGB: {topCigSales:[]},
          WGB : {topCigSales:[]},
        }
        this.$locations.forEach(location=>{
          result[location].topCigSales = this.data[location].topCigSales.filter(r=>{
            const itemName = r.ItemName.toLowerCase()
            const distributor = `${r.Distributor}`.toLowerCase()
            console.log(distributor)
            const distFilter = q.distributorFilter.toLowerCase()
            const inFilter = q.includeFilter.toLowerCase()
            const exFilter = q.excludeFilter.toLowerCase()
            
            const willFilter =  (inFilter.length> 0 ? itemName.includes(inFilter) : true) && (exFilter.length> 0 ? !itemName.includes(exFilter) : true) && (distFilter.length> 0 ? distributor.includes(distFilter) : true);
            return willFilter;

          })
        })
        return result;
      }

    }

  },
  filters: {
    
  }
}
</script>


<style scoped>

</style>

